type ClassValue = string | number | false | null | undefined;

/**
 * Concatena classes ignorando valores falsos.
 * Sem `clsx`/`tailwind-merge`: os componentes de `shared/ui` já compõem as
 * variantes de forma exclusiva, então não há conflito de classes a resolver.
 */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
